module.exports = __webpack_public_path__ + "generic.MYLQcPJp.svg";